<template>
    <!-- 迭代版本 -->
    <el-dialog class="dialog-version" v-if="dialogVersion" title="迭代版本记录" :visible.sync="dialogVersion">
        <el-scrollbar wrap-class="scrollbar-wrapper"  v-loading="versionLoading">
            <el-timeline v-if="versionsList.length > 0">
                <el-timeline-item icon="el-icon-circle-check" v-for="(item, index) in versionsList" :key="index" >
                    <span class="time">{{item.logTime}}</span>
                    <span class="user">{{item.userName}}</span>
                    <span class="desc">{{item.message}}</span>
                </el-timeline-item>
            </el-timeline>

            <span v-else-if="versionsList.length == 0 && !versionLoading" class="empty">暂无迭代信息</span>
        </el-scrollbar>
    </el-dialog>
</template>

<script>
import {flowStatusArr} from './transferDrawer/flowLogDict'
import {outsource_flowLogList} from "@File~/api/outsourcing";


export default {
    data() {
        return {
            dialogVersion: false,
            logLoading:false,
            versionLoading: false,
            versionsList:[]
        }
    },
    methods:{
        // 初始化
        init(row) {
            this.dialogVersion = true

            let that = this
            that.versionLoading = true;
            outsource_flowLogList(row.id).then((response) => {
                if (response.code == 1) {
                    that.versionsList = response.data
                    that.versionsList.map((item)=>{
                        for(let index = 0; index<flowStatusArr.length; index ++){
                            if(item.status === flowStatusArr[index].status){
                                item.message = flowStatusArr[index].message;
                            }
                            continue;
                        }
                    })
                    const showStatusList = [1,3,-4,4];
                    for(let index = that.versionsList.length-1;index >=0; index--){
                        if(showStatusList.indexOf(that.versionsList[index].status) === -1 ){
                            that.versionsList.splice(index,1)

                        }
                    }
                    that.versionLoading = false

                }
            });
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog-version{
        ::v-deep .el-dialog{
            min-width: 428px;
            max-width: 600px;
            width: auto;
            min-height: 286px;
            background: #FFFFFF;
            border-radius: 4px;
            top: 50%;
            margin-top: 0 !important;
            transform:translateY(-50%);
        }

        ::v-deep.el-dialog__header{
            height: 68px;
            padding: 0 32px;
            line-height: 68px;

            .el-dialog__title{
                font-weight: 500;
                color: #333333;
            }
        }

        ::v-deep .el-dialog__close{
            font-size: 28px;
            color:#999999;
        }

        ::v-deep .el-dialog__body{
            padding: 16px 24px;
            height:calc(100vh - 25vh);
        }
        ::v-deep .el-scrollbar{
            height: 100%;
        }
        ::v-deep .scrollbar-wrapper {
            overflow-x: hidden !important;
        }
        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }
        ::v-deep .el-timeline{
            padding: 10px;
        }
        ::v-deep .el-timeline-item__node{
            background-color: #e5e5e58f;
        }
        ::v-deep .el-timeline-item__icon{
            color: #3A89FF;
            font-size: 16px;
            font-weight: bold;
        }
        ::v-deep .el-timeline-item__tail{
            border-left: 2px solid #E5E5E5;
        }
        .empty{
            display:block; 
            line-height: 60px; 
            color: #909399; 
            text-align:center
        }

        .time{
            color: #666666;
        }
        .user{
            color: #3A89FF;
            margin: 0 8px 0 16px;
        }
        .desc{
            color: #333333;
        }
    }
</style>